<template>
  <v-card class="elevation-12">
    <v-form @submit.prevent="onLogIn" v-model="valid" ref="loginForm">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="py-0">
              <v-alert
                v-model="alert"
                type="error"
                close-text="Close"
                dismissible
              >{{ errorMessage }}</v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field class="py-0"
                label="E-Mail"
                name="username"
                id="username"
                v-model="username"
                prepend-icon="mdi-account"
                type="text"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0">
              <v-text-field class="py-0"
                id="password"
                label="Password"
                name="password"
                v-model="password"
                prepend-icon="mdi-lock"
                :type="show_pwd ? 'text' : 'password'"
                :append-icon="show_pwd ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                @click:append="show_pwd = !show_pwd"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-0"></v-col>
            <v-col class="py-0">
              <vue-recaptcha
                ref="recaptcha"
                @verify="onVerify"
                @expired="onExpired"
                :sitekey="sitekey"
                v-if="showCaptcha"
                :loadRecaptchaScript="true"
              ></vue-recaptcha>
            </v-col>
            <v-col class="py-0"></v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text small color="secondary">
          <small>Forgot my password</small>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="login_dialog({show: false})">Cancel</v-btn>
        <v-btn type="submit" color="primary" :loading="loading" :disabled="loading">Login</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { types as UserStoreTypes } from "../store/user";
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    source: String
  },
  data: () => ({
    username: "",
    password: "",
    sitekey: "6LcSQLEUAAAAACgW6Rbx5nuiPSsIrWBh2syUk_u0", //'6Lc5P7EUAAAAAMljM3BwrnpM47K-hiRjeH2C8BT_'
    reCaptchaVerify: "",
    show_pwd: false,
    valid: false,
    alert: false,
    rules: {
      required: value => !!value || "Required.",
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      }
    }
  }),
  computed: {
    ...mapState('Ui', ['login_redirect_url']),
    user() {
      return this.$store.getters[UserStoreTypes.getters.USER];
    },
    errorMessage() {
      if (this.$store.getters[UserStoreTypes.getters.ERROR_LOGIN] !== null) {
        return this.firebase_message(
          this.$store.getters[UserStoreTypes.getters.ERROR_LOGIN].code
        );
      } else {
        return "";
      }
    },
    loading() {
      return this.$store.getters[UserStoreTypes.getters.IS_LOGGING_IN];
    },
    showCaptcha() {
      if (this.$store.getters[UserStoreTypes.getters.ERROR_LOGIN]) {
        return (
          this.$store.getters[UserStoreTypes.getters.ERROR_LOGIN].code ==
          "auth/too-many-requests"
        );
      }
      return false;
    }
  },
  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        this.login_dialog({show: false});
        this.$router.push(this.login_redirect_url)
        .catch(() => {
        });
      }
    },
    errorMessage(value) {
      if (value && value.length > 0) {
        this.alert = true;
      } else {
        this.alert = false;
      }
    },
    alert(value) {
      if (!value) {
        this.$store.commit(UserStoreTypes.mutations.ERROR_LOGIN, null);
      }
    },
    loading() {
    },
    showCaptcha() {
    }
  },
  methods: {
    ...mapMutations('Ui', ['login_dialog']),
    onLogIn() {
      if (this.$refs.loginForm.validate()) {
        this.$store.dispatch(UserStoreTypes.actions.LOGIN, {
          username: this.username,
          password: this.password,
          reCaptcha: this.reCaptchaVerify
        });
      }
    },
    onVerify: function(response) {
      this.reCaptchaVerify = response;
      this.$store.commit(UserStoreTypes.mutations.ERROR_LOGIN, null);
    },
    onExpired: function() {},
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    }
  },

  mounted() {},
  components: {
    "vue-recaptcha": VueRecaptcha
  }
};
</script>
